module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app.component.html
// module id = ./src/app/components/app.component.html
// module chunks = main